import { useQuery } from "@tanstack/react-query";

import { getOrderMetadata } from "../services/orderMetadata";

export const useOrderMetadata = (orderId: string) =>
  useQuery({
    enabled: !!orderId,
    queryFn: () => getOrderMetadata(orderId),
    queryKey: ["order-metadata", orderId],
    retry: false,
  });
